<template>
  <div :class="['sidebar__items', { reduced }]">
    <div
      v-for="item in items"
      :key="item.name"
    >
      <router-link
        :to="item"
        class="sidebar__items-item"
        active-class="active"
        v-slot="{ isActive }"
      >
        <div class="sidebar__items-item-icon">
          <BasicIcon
            :name="item.meta.icon!"
            :active="isActive"
            color="secondary-800"
          />
        </div>
        <BasicText
          v-if="!reduced"
          class="sidebar__items-item-label"
          wrap
          nb-max-lines="2"
          color="secondary-900"
        >
          {{ item.meta.label }}
        </BasicText>
      </router-link>
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { RouteRecordNormalized } from 'vue-router'

  type SidebarItemsProps = {
    reduced?: boolean
    items?: RouteRecordNormalized[]
  }

  withDefaults(defineProps<SidebarItemsProps>(), {
    reduced: false,
    items: () => [] as RouteRecordNormalized[],
  })
</script>

<style lang="less">
  @import 'SidebarItems.less';
</style>
